import type { HotelMapView } from '../models.js';
import { HotelMap } from '../results/hotel_map.js';

export function HotelDetailsLocation({
  label,
  heading,
  map,
  distanceLabel,
  travelTimeLabel,
}: {
  readonly label?: string;
  readonly heading: string;
  readonly map?: HotelMapView;
  readonly distanceLabel?: string;
  readonly travelTimeLabel?: string;
}) {
  const travelLabel = [distanceLabel, travelTimeLabel].filter(Boolean).join(' · ');

  return (
    <section className="genui2 hui-hotel-details-location">
      <h3>{heading}</h3>
      {map && (
        <HotelMap
          map={map}
          offers={[]}
          selectLabel=""
          detailsLabel=""
          onHotelSelect={() => undefined}
          onDetailsOpen={() => undefined}
        />
      )}
      {travelLabel && <p className="hui-hotel-details-location-travel">{travelLabel}</p>}
      {label && <p className="hui-hotel-details-location-address">{label}</p>}
    </section>
  );
}
